import { render, staticRenderFns } from "./data-import.vue?vue&type=template&id=24d45fb1&scoped=true"
import script from "./data-import.vue?vue&type=script&lang=ts"
export * from "./data-import.vue?vue&type=script&lang=ts"
import style0 from "./data-import.vue?vue&type=style&index=0&id=24d45fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d45fb1",
  null
  
)

export default component.exports